import {createDocument,updateDocument,removeDocument} from '../api/document';

import {getErrors} from '../utils/tools';


/*
  Enregistre un nouveau document
*/
export function createDocumentAction(data) {
  return(dispatch)=>{
    return this.loggedIn().then((res) => { // Vérifie l'authentification
      const token = localStorage.getItem("id_token")
      return createDocument(token, data)
        .then(res => {
          dispatch({
              type:"ADD_DOCUMENT_TO_REPORT",
              document:res,
              report: data.report
          });
          this.displaySnackbar("success", "Document enregistré");
          return res
        })
        .catch((err)=>{
          let errors = getErrors(err)
          this.displaySnackbar("error", errors[0].message);
          throw err
        })
    })
  }
}

/*
  Met à jour un document
*/
export function updateReportDocumentAction(report, id, document, data) {
  return(dispatch)=>{
    dispatch({
        type:"UPDATE_DOCUMENT",
        report: report,
        document:document
    });
    return this.loggedIn().then((res) => { // Vérifie l'authentification
      const token = localStorage.getItem("id_token")
      return updateDocument(token, id, data)
        .then(res => {

          this.displaySnackbar("success", "Document modifié");
          return res
        })
        .catch((err)=>{
          let errors = getErrors(err)
          this.displaySnackbar("error", errors[0].message);
          throw err
        })
    })
  }
}

/*
  Supprimer un document
*/
export function removeDocumentAction(report, id) {
  return(dispatch)=>{
    return this.loggedIn().then((res) => { // Vérifie l'authentification
      const token = localStorage.getItem("id_token")
      return removeDocument(token, id)
        .then(res => {
          dispatch({
              type:"REMOVE_DOCUMENT",
              report: report,
              id:id
          });
          this.displaySnackbar("success", "Document supprimé");
          return res
        })
        .catch((err)=>{
          let errors = getErrors(err)
          this.displaySnackbar("error", errors[0].message);
          throw err
        })
    })
  }
}



// WEBPACK FOOTER //
// ./src/actions/document.js